import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { AVAILABILITY_FEATURE, AvailabilityState, StateWithAvailability } from '../availability-state';

export const getAvailabilityFeatureState: MemoizedSelector<StateWithAvailability, AvailabilityState> =
  createFeatureSelector<AvailabilityState>(AVAILABILITY_FEATURE);
